// extracted by mini-css-extract-plugin
module.exports = {"CheckoutSummary":"checkoutsummary_CheckoutSummary__2Nebz"};